import { render, staticRenderFns } from "./TradingView.vue?vue&type=template&id=4bc62052&"
import script from "./TradingView.vue?vue&type=script&lang=js&"
export * from "./TradingView.vue?vue&type=script&lang=js&"
import style0 from "./TradingView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports